/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Share_Get_ErrorInputs */

const en_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error getting shares. ${i?.message}`)
};

const fr_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la récupération des partages. ${i?.message}`)
};

const de_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Anteile. ${i?.message}`)
};

const it_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'acquisizione delle condivisioni. ${i?.message}`)
};

const ru_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при получении акций. ${i?.message}`)
};

const es_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al obtener acciones. ${i?.message}`)
};

const zh_cn2_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`获取份额时出错。${i?.message}`)
};

const ja_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共有の取得中にエラーが発生しました。${i?.message}`)
};

const hi_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शेयर प्राप्त करने में त्रुटि। ${i?.message}`)
};

const pt_pt2_team_share_get_error = /** @type {(inputs: Team_Share_Get_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao obter ações. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error getting shares. {message}" |
*
* @param {Team_Share_Get_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_get_error = /** @type {((inputs: Team_Share_Get_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Get_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_get_error(inputs)
	if (locale === "de") return de_team_share_get_error(inputs)
	if (locale === "it") return it_team_share_get_error(inputs)
	if (locale === "ru") return ru_team_share_get_error(inputs)
	if (locale === "es") return es_team_share_get_error(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_get_error(inputs)
	if (locale === "ja") return ja_team_share_get_error(inputs)
	if (locale === "hi") return hi_team_share_get_error(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_get_error(inputs)
	return en_team_share_get_error(inputs)
});